// ExtractionProgressBar - a determinate "transcribed N of M pages…" bar shown on
// a file row while a large scanned PDF is being OCR'd across worker segments
// (extraction_status === "running"). Fed by the upload row's extraction_progress,
// which rides the single /uploads/list poll (no per-file poll), and advances live
// because useUploadsList interval-refetches while anything is "running".
import type { ExtractionProgress } from "../api/hooks/useUploadsList";

const WRAP: React.CSSProperties = {
  display: "inline-flex",
  flexDirection: "column",
  gap: 2,
  marginLeft: 8,
  minWidth: 160,
  verticalAlign: "middle",
};

const TRACK: React.CSSProperties = {
  position: "relative",
  height: 4,
  width: "100%",
  background: "#e5e7eb",
  borderRadius: 2,
  overflow: "hidden",
};

const LABEL: React.CSSProperties = {
  fontSize: 11,
  color: "#6b7280",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: 280,
};

export const ExtractionProgressBar = ({
  progress,
}: {
  progress: ExtractionProgress;
}): JSX.Element => {
  const { done, total, label } = progress;
  const pct = total > 0 ? Math.min(100, Math.round((done / total) * 100)) : 0;
  const text =
    label || (total > 0 ? `Transcribed ${done} of ${total} pages…` : "Reading…");
  return (
    <span style={WRAP} title={text}>
      <span style={TRACK} role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100} aria-label={text}>
        <span
          style={{
            position: "absolute",
            inset: 0,
            width: `${pct}%`,
            background: "#3b82f6",
            transition: "width 0.4s ease",
          }}
        />
      </span>
      <span style={LABEL}>{text}</span>
    </span>
  );
};
